import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orderFilterType: null,
};

export const orderFiltersSlice = createSlice({
  name: "orderFilters",
  initialState,
  reducers: {
    setOrderFilterType: (state, action) => {
      state.orderFilterType = action.payload;
    },
  },
});

export const { setOrderFilterType } = orderFiltersSlice.actions;

export const getOrderFilterType = (state) => state.orderFilters.orderFilterType;

export default orderFiltersSlice.reducer;
